import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/logos/logo_1.jpg'
import _imports_1 from '@/assets/logos/logo_2.jpg'
import _imports_2 from '@/assets/logos/logo_3.jpg'
import _imports_3 from '@/assets/logos/logo_4.jpg'
import _imports_4 from '@/assets/logos/logo_5.jpg'


const _hoisted_1 = { class: "section-hero" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "hero" }
const _hoisted_4 = { class: "hero__tag" }
const _hoisted_5 = { class: "hero__title" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = {
  key: 0,
  class: "hero__btn"
}
const _hoisted_9 = { class: "section-tenders" }
const _hoisted_10 = { class: "container" }
const _hoisted_11 = { class: "tenders" }
const _hoisted_12 = { class: "tenders__logos" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1)
const _hoisted_18 = { class: "tenders__list" }
const _hoisted_19 = { class: "more-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderMain = _resolveComponent("HeaderMain")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_SearchBar = _resolveComponent("SearchBar")!
  const _component_TenderCard = _resolveComponent("TenderCard")!
  const _component_TheFooter = _resolveComponent("TheFooter")!
  const _component_FooterMobile = _resolveComponent("FooterMobile")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeaderMain),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("landing.hero_tag")), 1),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_i18n_t, {
              keypath: "landing.hero_title",
              tag: "h1"
            }, {
              break: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_i18n_t, {
            keypath: "landing.hero_text",
            tag: "div",
            class: "hero__text"
          }, {
            break: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          (!_ctx.isAuthenticated)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_RouterLink, {
                  to: { path: '/procedures', query: { page: '1' }},
                  onClick: _ctx.handleHeroBtn,
                  class: "btn btn-blue"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("search.search_purchases_btn")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("main", null, [
      _createElementVNode("section", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_RouterLink, { to: { path: '/procedures', query: { page: '1', source: 'xarid.uzex.uz'}} }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              }, 8, ["to"]),
              _createVNode(_component_RouterLink, { to: { path: '/procedures', query: { page: '1', source: 'hayotbirja.uz'}} }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              }, 8, ["to"]),
              _createVNode(_component_RouterLink, { to: { path: '/procedures', query: { page: '1', source: 'etender.uzex.uz'}} }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              }, 8, ["to"]),
              _createVNode(_component_RouterLink, { to: { path: '/procedures', query: { page: '1', source: 'tender.mc.uz'}} }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              }, 8, ["to"]),
              _createVNode(_component_RouterLink, { to: { path: '/procedures', query: { page: '1', source: 'beeline.uz'}} }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createVNode(_component_SearchBar),
            _createElementVNode("div", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTenders.data, (tender) => {
                return (_openBlock(), _createBlock(_component_TenderCard, {
                  tender: tender,
                  key: tender.id
                }, null, 8, ["tender"]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_RouterLink, {
              to: { path: '/procedures', query: { page: '1' } },
              class: "btn btn-blue"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("landing.more_btn")), 1)
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createVNode(_component_TheFooter),
    _createVNode(_component_FooterMobile)
  ], 64))
}